import request from '@/utils/request'
import host from '@/api/base/host'

// 订单模块
const coupon = host.path('dev', { module: 'coupon', dev: 'v1/coupon' }) // 开发地址:ljs

export default {
  // 列表
  getCouponListByLink(data) {
    return request({ url: coupon('getCouponListByLink'), method: 'post', data })
  },
  // 领取
  obtainCouponByLink(data) {
    return request({ url: coupon('obtainCouponByLink'), method: 'post', data })
  }
}
